// the value is stored as photo_1234 in the db, so we may need to strip off the photo_ part
export const getPhotoIdFromKey = (input: string | number | null | undefined = ''): number | null => {
  let returnVal = null
  if (input !== null && input !== undefined && input !== '') {
    if (typeof input === 'string') {
      const match = input.match(/^photo_(\d+)$/)
      if (match) {
        returnVal = Number(match[1])
      } else {
        returnVal = Number(input)
      }
    } else if (typeof input === 'number') {
      returnVal = input
    }
  }
  return returnVal
}

export const getPhotoKeyFromId = (input: string | number | null | undefined): string | null => {
  if (input === null || input === undefined || input === '') return null
  if (typeof input === 'string') return input
  const photoId = Number(input)
  return !isNaN(photoId) ? `photo_${photoId}` : null
}
